import React from 'react';
import { WebView } from 'react-native-webview';

export default function TestWebView() {
  return (
    <WebView
      source={{ uri: 'https://dev.hereworks.tech/H1026100W?ss=QR' }}
      style={{ flex: 1 }}
      javaScriptEnabled={true}
      allowsInlineMediaPlayback={true}
      mediaPlaybackRequiresUserAction={false}
      />
  );
}
